/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
//import router from '@/router';
import _ from 'lodash';
import moment from "moment-timezone";
export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  async fetchEmployee({commit}){
    const _users = (await firebase.database().ref(`/employee`).once('value')).val();
    const users = [];
    for(const x in _users){
      if(_users[x].email !== 'super@gmail.com' && _users[x].email !== 'pond@ufs896||com'){
        _users[x].key = x;
        users.push(_users[x]);
      }
    }
    console.log(users);
    commit('SET_EMPLOYEE',users);
  },
  resetUser({commit}){
    commit('RESET_USER');
  },
  fetchUsers14 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/14').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 14;
          user.datetimeshow = moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    });
    //commit('SET_USERS', []);
  },
  fetchUsers15 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/15').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 15;
          user.datetimeshow = moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    });
    //commit('SET_USERS', []);
  },

  fetchUsers3 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/3').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 3;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers4 ({ commit }) {
    commit('SET_USERS', []);
    //const data = localStorage.getItem('userInfo');
    //const user = JSON.parse(data);
    /*if (user.company === undefined || user.company === '') {
      await firebase.auth().signOut().then(() => {
        router.push('/login').catch(() => {})
      });
    }*/
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/4').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 4;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers16 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/16').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 16;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers19 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/19').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 19;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers27 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/27').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 27;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers28 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/28').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 28;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers29 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/29').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 29;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers40 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/40').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 40;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers41 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/41').orderByChild('datetime').limitToLast(20).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 40;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers42 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/42').orderByChild('datetime').limitToLast(20).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 40;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers5 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/5').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 5;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers6 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/6').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 6;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers11 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/11').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 11;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        console.log(first);
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers13 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/13').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 13;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsers1 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/1').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 1;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers2 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/2').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 2;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers20 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/20').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 20;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers21 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/21').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 21;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers22 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/22').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 22;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers26 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/26').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 26;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers30 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/30').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 30;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers31 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/31').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 31;
          user.datetimeshow= moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    })
    //commit('SET_USERS', []);
  },
  fetchUsers32 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/32').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 32;
          user.datetimeshow = moment(user.datetime,'YYYY-MM-DD HH:mm').tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error)});
    });
    //commit('SET_USERS', []);
  },
  fetchUsersHuay ({ commit }, number) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/'+number).orderByChild('datetime').limitToLast(30).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = number;
          user.datetimeshow = moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
          if(number === 7 && Number(moment().tz('Asia/Bangkok').format('HHmm')) >= 915 && Number(moment().tz('Asia/Bangkok').format('HHmm')) <= 1315){
            const d2 = user.datetime2.split(' ')
            const date2 = d2[0].split('-')
            const time2 = d2[1].split(':')
            const datetime2 = Number(date2[0] + '' + date2[1] + '' + date2[2] + '' + time2[0] + '' + time2[1])
            if (datetime2 > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
              first = user.datetime2;
            }
          }else if(number === 14 && Number(moment().tz('Asia/Bangkok').format('HHmm')) >= 1050 && Number(moment().tz('Asia/Bangkok').format('HHmm')) <= 1450){
            const d2 = user.datetime2.split(' ')
            const date2 = d2[0].split('-')
            const time2 = d2[1].split(':')
            const datetime2 = Number(date2[0] + '' + date2[1] + '' + date2[2] + '' + time2[0] + '' + time2[1])
            if (datetime2 > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
              first = user.datetime2;
            }
          }else if(number === 8 && Number(moment().tz('Asia/Bangkok').format('HHmm')) >= 1115 && Number(moment().tz('Asia/Bangkok').format('HHmm')) <= 1515){
            const d2 = user.datetime2.split(' ')
            const date2 = d2[0].split('-')
            const time2 = d2[1].split(':')
            const datetime2 = Number(date2[0] + '' + date2[1] + '' + date2[2] + '' + time2[0] + '' + time2[1])
            if (datetime2 > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
              first = user.datetime2;
            }
          }else if(number === 9 && Number(moment().tz('Asia/Bangkok').format('HHmm')) >= 1015 && Number(moment().tz('Asia/Bangkok').format('HHmm')) <= 1415){
            const d2 = user.datetime2.split(' ')
            const date2 = d2[0].split('-')
            const time2 = d2[1].split(':')
            const datetime2 = Number(date2[0] + '' + date2[1] + '' + date2[2] + '' + time2[0] + '' + time2[1])
            if (datetime2 > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
              first = user.datetime2;
            }
          }else if(number === 17 && Number(moment().tz('Asia/Bangkok').format('HHmm')) >= 1215){
            const d2 = user.datetime2.split(' ')
            const date2 = d2[0].split('-')
            const time2 = d2[1].split(':')
            const datetime2 = Number(date2[0] + '' + date2[1] + '' + date2[2] + '' + time2[0] + '' + time2[1])
            if (datetime2 > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
              first = user.datetime2;
            }
          }else if(number === 18 && Number(moment().tz('Asia/Bangkok').format('HHmm')) >= 2115){
            const d2 = user.datetime2.split(' ')
            const date2 = d2[0].split('-')
            const time2 = d2[1].split(':')
            const datetime2 = Number(date2[0] + '' + date2[1] + '' + date2[2] + '' + time2[0] + '' + time2[1])
            if (datetime2 > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
              first = user.datetime2;
            }
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    });
    //commit('SET_USERS', []);
  },
  fetchUsersByWebNumber ({ commit }, webNumber) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child(`huay/${webNumber}`).orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = webNumber;
          user.datetimeshow = moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    });
    //commit('SET_USERS', []);
  },
  fetchRedeems ({ commit }){
    firebase.database().ref().child('redeems').once('value', (snapshot) => {
      let rewards = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        rewards.push(user)
      });
      rewards = _.orderBy(rewards, ['createdate'],['desc']);
      commit('SET_REDEEMS', rewards);
    });
  },
  fetchRewards ({ commit }){
    firebase.database().ref().child('rewards').once('value', (snapshot) => {
      let rewards = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        rewards.push(user)
      });
      rewards = _.orderBy(rewards, ['createdate'],['desc']);
      commit('SET_REWARDS', rewards);
    });
  },
  fetchUsers39 ({ commit }) {
    commit('SET_USERS', []);
    let first = '';
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/39').orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 39;
          user.datetimeshow = moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    });
    //commit('SET_USERS', []);
  },
  fetchUsers ({ commit,rootState }) {
    commit('SET_USERS', []);
    //const data = localStorage.getItem('userInfo');
    //const user = JSON.parse(data);
    /*if (user.company === undefined || user.company === '') {
      await firebase.auth().signOut().then(() => {
        router.push('/login').catch(() => {})
      });
    }*/
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('huay/'+rootState.AppActiveUser.web).orderByChild('datetime').limitToLast(100).once('value', (snapshot) => {
        let users = []; 
        let first = '';
        snapshot.forEach((data) => {
          const user = data.val();
          user.key = data.key;
          user.web = 1;
          user.datetimeshow = moment(user.datetime).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm');
          users.push(user)
          const d = user.datetime.split(' ')
          const date = d[0].split('-')
          const time = d[1].split(':')
          const datetime = Number(date[0] + '' + date[1] + '' + date[2] + '' + time[0] + '' + time[1])
          if (datetime > Number(moment().tz('Asia/Bangkok').format('YYYYMMDDHHmm')) && !first) {
            first = user.datetime;
          }
        });
        
        users = _.orderBy(users, ['datetime'],['desc']);
        commit('SET_USERS', users);
        commit('SET_FIRST', first);
        resolve();
      }).catch((error) => { reject(error) });
    });
    //commit('SET_USERS', []);
  },
  fetchUser ({commit}, userId) {
    console.log(userId);
    return new Promise((resolve, reject) => {
      commit('SET_HISTORY', []);
      firebase.database().ref().child('users').orderByChild('userId').equalTo(userId).once('value', async (snapshot2) => {
        let userId = '';
        snapshot2.forEach((snapshot)=>{
          commit('SET_USER', snapshot.val());
          userId = snapshot.val().userId;
        });
        const rows = [];
        let dataTotal = 0;
        let withdrawTotal = 0;
        let depositTotal = 0;
        await firebase.firestore().collection('roulet').where('userId','==',userId).get().then((result)=>{
          result.forEach((doc)=>{
            rows.push({
              type:'รูเล็ต',
              createdate:doc.data().createdate,
              qty:doc.data().value,
            });
          });
        });
        await firebase.firestore().collection('sharefriend').where('userId','==',userId).get().then((result)=>{
          result.forEach((doc)=>{
            rows.push({
              type:'แนะนำเพื่อน 15%',
              createdate:doc.data().createdate,
              qty:doc.data().value,
            });
          });
        });
        await firebase.firestore().collection('waste').where('userId','==',userId).get().then((result)=>{
          result.forEach((doc)=>{
            rows.push({
              type:'คืนยอดเสีย',
              createdate:doc.data().createdate,
              qty:doc.data().waste,
            });
          });
        });
        await firebase.firestore().collection('redeemreward').where('userId','==',userId).get().then((result)=>{
          result.forEach((doc)=>{
            rows.push({
              type:'แลกเหรียญ',
              createdate:doc.data().createdate,
              qty:doc.data().credit,
            });
          });
        });
        await firebase.firestore().collection('history').where('status','==','ดำเนินการแล้ว').where('userId','==',userId).orderBy('createdate','desc').get().then((result)=>{
          result.forEach((doc)=>{
              const qty = (doc.data().type === 'ฝาก')?'-'+doc.data().qty:doc.data().qty;
              dataTotal += Number(qty.toString().replace(/,/g,''));
              rows.push(doc.data());
              if(doc.data().type === 'ถอน'){
                withdrawTotal += Number(qty.toString().replace(/,/g,''));
              }else{
                depositTotal += Number(qty.toString().replace(/,/g,''));
              }
          });
        });
        commit('SET_DEPOSIT_TOTAL', depositTotal);
        commit('SET_WITHDRAW_TOTAL', withdrawTotal);
        commit('SET_TOTAL', dataTotal);
        commit('SET_HISTORY', _.orderBy(rows, ['createdate'],['desc']));
        resolve();
      }).catch((error) => { reject(error) });
    })
  },
  fetchHistory({commit},{userId,startdate,enddate}){
    return new Promise((resolve, reject) => {
      commit('SET_HISTORY', []);
      firebase.database().ref().child('users').orderByChild('userId').equalTo(userId).once('value', (snapshot2) => {
        snapshot2.forEach((snapshot)=>{
          firebase.firestore().collection('history').where('status','==','ดำเนินการแล้ว').where('userId','==',snapshot.val().userId).where('createdate','>=',`${startdate} 00:00`).where('createdate','<=',`${enddate} 23:59`).orderBy('createdate','desc').get().then((result)=>{
            let depositTotal = 0;
            let withdrawTotal = 0;
            let dataTotal = 0;
            const data = [];
            result.forEach((doc)=>{
                const qty = (doc.data().type === 'ฝาก')?'-'+doc.data().qty:doc.data().qty;
                dataTotal += Number(qty.toString().replace(/,/g,''));
                data.push(doc.data());
                if(doc.data().type === 'ถอน'){
                  withdrawTotal += Number(qty.toString().replace(/,/g,''));
                }else{
                  depositTotal += Number(qty.toString().replace(/,/g,''));
                }
            });
            commit('SET_DEPOSIT_TOTAL', depositTotal);
            commit('SET_WITHDRAW_TOTAL', withdrawTotal);
            commit('SET_TOTAL', dataTotal);
            commit('SET_HISTORY', data);
          });
          resolve();
        });
      }).catch((error) => { reject(error) });
    })
  },
  updateUsers({state,commit}, {key,value}){
    const users = state.users;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_USERS', users);
    }
  },
  updateRewards({state,commit}, {key,value}){
    const users = state.rewards;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_REWARDS', users);
    }
  },
  updateRedeems({state,commit}, {key,value}){
    const users = state.redeems;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_REDEEMS', users);
    }
  },
  /*fetchUser ({commit}, userId) {
    const data = localStorage.getItem('userInfo');
    const user = JSON.parse(data);
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('users').orderByChild('company').equalTo(user.company).once('value', (snapshot) => {
        snapshot.forEach((arrData) => {
          if(arrData.val().code == userId){
            const user = arrData.val();
            if(user.avatar)
              user.avatar_path = user.avatar;
            user.edit = true;
            delete user.password;
            commit('SET_USER', user);
            resolve(user);
          } 
        });
      }).catch((error) => { reject(error) });
    })
    return new Promise((resolve, reject) => {
      axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },*/
  async updateFieldUsers({rootState},{key,value,column}) {
    if(key){
      console.log(rootState);
      firebase.database().ref('users/'+key).update({
        [`${column}`]:value,
      });
    }
  },
  async updateFieldRewards({rootState},{key,value,column}) {
    if(key){
      console.log(rootState);
      firebase.database().ref('rewards/'+key).update({
        [`${column}`]:value,
      });
    }
  },
  async getUsersOption({commit}){
    const datetime = moment().tz("Asia/Bangkok").add(-7,'days').format("YYYY-MM-DD HH:mm:ss");
    const redeem = (await firebase.database().ref(`/redeems`).orderByChild('createdate').startAt(datetime).once('value')).val();
    const u = [];
    for(const x in redeem){
      u[redeem[x].web+'-'+redeem[x].username] = true;
    }
    firebase.database().ref().child('users').orderByChild('status').equalTo('Y').once('value', (snapshot) => {
      const users = [];
      snapshot.forEach((arrData) => {
        if(arrData.val().web && arrData.val().username && !u[arrData.val().web+'-'+arrData.val().username])
        users.push(arrData.val());
      });
      const _users = _.orderBy(users, ['username'],['asc']);
      commit('SET_USEROPTION', _users);
    })
  },
  getRewardsOption({commit}){
    firebase.database().ref().child('rewards').orderByChild('status').equalTo('Y').once('value', (snapshot) => {
      const users = [];
      snapshot.forEach((arrData) => {
        users.push(arrData.val());
      });
      const _users = _.orderBy(users, ['code'],['asc']);
      commit('SET_REWARDOPTION', _users);
    })
  },
  getUsersOptionTrueWallet({commit}){
    firebase.database().ref().child('users').orderByChild('bank').equalTo('truewallet').once('value', (snapshot) => {
      const users = [];
      snapshot.forEach((arrData) => {
        users.push({
          code:arrData.val().code,
          userId:arrData.val().userId
        });
      });
      const _users = _.orderBy(users, ['code'],['asc']);
      commit('SET_USEROPTION_TRUEWALLET', _users);
    })
  },
  removeRecord (userId) {
    return new Promise(() => {
      firebase.database().ref('users/'+userId).remove();
    })
  },
  fetchBanners ({ commit,rootState }){
    firebase.database().ref().child('banners/'+rootState.AppActiveUser.web).once('value', (snapshot) => {
      let banners = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        user.web = 1;
        banners.push(user)
      });
      banners = _.orderBy(banners, ['createdate'],['desc']);
      commit('SET_BANNERS', banners);
    });
  },
  fetchBanners2 ({ commit }){
    firebase.database().ref().child('banners/2').once('value', (snapshot) => {
      let banners = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        user.web = 2;
        banners.push(user)
      });
      banners = _.orderBy(banners, ['createdate'],['desc']);
      commit('SET_BANNERS', banners);
    });
  },
  fetchBanners3 ({ commit }){
    firebase.database().ref().child('banners/3').once('value', (snapshot) => {
      let banners = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        user.web = 3;
        banners.push(user)
      });
      banners = _.orderBy(banners, ['createdate'],['desc']);
      commit('SET_BANNERS', banners);
    });
  },
  fetchBanners4 ({ commit }){
    firebase.database().ref().child('banners/4').once('value', (snapshot) => {
      let banners = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        user.web = 4;
        banners.push(user)
      });
      banners = _.orderBy(banners, ['createdate'],['desc']);
      commit('SET_BANNERS', banners);
    });
  },
  fetchBanners5 ({ commit }){
    firebase.database().ref().child('banners/5').once('value', (snapshot) => {
      let banners = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        user.web = 5;
        banners.push(user)
      });
      banners = _.orderBy(banners, ['createdate'],['desc']);
      commit('SET_BANNERS', banners);
    });
  },
  fetchBanners6 ({ commit }){
    firebase.database().ref().child('banners/6').once('value', (snapshot) => {
      let banners = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        user.web = 6;
        banners.push(user)
      });
      banners = _.orderBy(banners, ['createdate'],['desc']);
      commit('SET_BANNERS', banners);
    });
  },
}
